import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  Platform,
} from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  Helpers,
  Typo,
  article,
  pageCover,
  FontFamily,
  popularStories,
  Colors,
} from "../../styles/appStyles";
import { helpers } from "../../utils/helpers";
import PageBreak from "../page-break";
import TouchableOpacityLink from "../touchable-opacity-link";
import getImagePath from "../../utils/image-helper";
import CustomImage from "../custom-image";
import Cookies from "universal-cookie";
import AuthenticationWrapper from "../authentication-wrapper";

const Startup = getImagePath("img/startup-img.png");
const Fintech = getImagePath("img/fintech-img.png");
const Retail = getImagePath("img/retail-img.png");
const eccomerce = getImagePath("img/eccomerce-img.png");
const media = getImagePath("img/media-img.png");

//mobile
const StartupMobImg = getImagePath("img/m-startup-img.png");
const FintechMobImg = getImagePath("img/m-fintech-img.png");
const RetailMobImg = getImagePath("img/m-retail-img.png");
const eccomerceMobImg = getImagePath("img/m-ecomerce-img.png");
const mediaMobImg = getImagePath("img/m-media-img.png");

const cookies = new Cookies();

export class HomePopularCategories extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    const { isAuthenticated, fetchToken } = this.props.auth;
    let token = webView
      ? process.browser
        ? isAuthenticated
          ? fetchToken
          : false
        : this.props.token
      : this.props.user?.userData?.data?.token;
    this.state = {
      showToken: !helpers.isWeb() || process.browser ? true : false,
    };
  }

  componentDidMount = () => {};

  trackThemeClick = (theme) => {
    if (this.props.trackThemeClick) {
      this.props.trackThemeClick(theme);
    }
  };

  render() {
    const { transparentBg, data, subscription, getTagClick, darkMode } =
      this.props;
    let startUpProp,
      fintechProp,
      environmentProp,
      eCommProp,
      technologyProp,
      telecomProp,
      edtechProp,
      itProp,
      financeProp,
      retailProp,
      mediaProp;
    let webView = helpers.isWeb();
    if (helpers.isWeb()) {
      startUpProp = {
        to: "/tag/startups?longreads=true",
      };
      fintechProp = {
        to: "/tag/fintech?longreads=true",
      };
      eCommProp = {
        to: "/tag/ecommerce?longreads=true",
      };
      retailProp = {
        to: "/tag/retail?longreads=true",
      };
      mediaProp = {
        to: "/tag/media-entertainment?longreads=true",
      };
      technologyProp = {
        to: "/tag/aviation?longreads=true",
      };
      telecomProp = {
        to: "/tag/telecom?longreads=true",
      };
      edtechProp = {
        to: "/tag/edtech?longreads=true",
      };
      itProp = {
        to: "/tag/infotech?longreads=true",
      };
      environmentProp = {
        to: "/tag/environment?longreads=true",
      };
      financeProp = {
        to: "/tag/banking-finance?longreads=true",
      };
    } else {
      startUpProp = {
        onPress: () => getTagClick("startups"),
      };
      fintechProp = {
        onPress: () => getTagClick("fintech"),
      };
      eCommProp = {
        onPress: () => getTagClick("ecommerce"),
      };
      retailProp = {
        onPress: () => getTagClick("retail"),
      };
      mediaProp = {
        onPress: () => getTagClick("media-entertainment"),
      };
      technologyProp = {
        onPress: () => getTagClick("aviation"),
      };
      telecomProp = {
        onPress: () => getTagClick("telecom"),
      };
      edtechProp = {
        onPress: () => getTagClick("edtech"),
      };
      itProp = {
        onPress: () => getTagClick("infotech"),
      };
      environmentProp = {
        onPress: () => getTagClick("environment"),
      };
      financeProp = {
        onPress: () => getTagClick("banking-finance"),
      };
    }
    return (
      <View
        style={[
          helpers.isDesktop() ? Flex.row : Flex.column,
          Flex.alignCenter,
          Flex.justfiyCenter,
          Padding.pb_3,
          helpers.isDesktop() && Padding.ph_4,
          !helpers.isDesktop() && {
            alignItems: "center",
            paddingTop: 30,
            paddingBottom: 48,
          },
          {
            backgroundColor: transparentBg
              ? "transparent"
              : darkMode
              ? Colors.darkBlackColorBg
              : "#f3f5ff",
          },
        ]}
      >
        <View style={{ maxWidth: 1000 }}>
          <View
            style={[
              helpers.isDesktop() &&
                {
                  // marginLeft: 'auto',
                  // marginRight: 'auto',
                  // right: helpers.isDesktop() ? 485 : 0
                },
            ]}
          >
            {!subscription && (
              <View style={[Flex.alignStart]}>
                <View
                  style={[
                    Helpers.titleBgWrap,
                    {
                      backgroundColor: "transparent",
                      width: helpers.isDesktop() ? "auto" : "100%",
                    },
                  ]}
                >
                  {!helpers.isDesktop() ? (
                    <Text
                      style={[
                        Helpers.textCenter,
                        Typo.h3_R,
                        helpers.isDesktop() && Typo.h3_RDesktop,
                        Margin.mb_0,
                        helpers.isWeb() && {
                          marginLeft: helpers.isDesktop() ? 50 : 0,
                        },
                        { fontFamily: FontFamily.abrilFatface },
                        {
                          fontSize: helpers.isDesktop() ? 34 : 34,
                          lineHeight: 51,
                          color: "#000",
                          fontWeight: 400,
                        },
                        !helpers.isDesktop() && {
                          paddingBottom: 22,
                          color: "#051462",
                        },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                      ]}
                    >
                      {data.title}
                    </Text>
                  ) : (
                    <Text
                      style={[
                        Helpers.textCenter,
                        Typo.h3_R,
                        helpers.isDesktop() && Typo.h3_RDesktop,
                        Margin.mb_0,
                        { fontFamily: FontFamily.abrilFatface },
                        {
                          fontSize: helpers.isDesktop() ? 34 : 20,
                          color: "#000",
                        },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                      ]}
                    >
                      Popular Themes
                    </Text>
                  )}
                </View>
              </View>
            )}
          </View>
          <View
            style={[
              Helpers.conatinerWeb,
              {
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: helpers.isDesktop() ? "flex-start" : "center",
              },
              helpers.isDesktop() && Helpers.conatinerWebFull,
              helpers.isDesktop() && Margin.mt_4,
            ]}
          >
            {subscription && (
              <View
                style={[
                  {
                    borderWidth: 1,
                    borderColor: "#7B8FFE",
                    borderRadius: 30,
                    backgroundColor: "#fff",
                  },
                  helpers.isDesktop() && { margin: 10 },
                ]}
              >
                <View
                  style={[
                    Flex.alignCenter,
                    helpers.isDesktop() && Margin.mb_7,
                    !helpers.isDesktop() && Margin.mb_4,
                    {
                      width: helpers.isWeb() ? "fit-content" : "100%",
                      marginLeft: "auto",
                      marginRight: "auto",
                    },
                  ]}
                >
                  <View
                    style={[
                      Padding.ph_2,
                      Helpers.titleBgWrap,
                      { backgroundColor: "transparent" },
                    ]}
                  >
                    <Text
                      style={[
                        Helpers.textCenter,
                        Typo.h3_R,
                        helpers.isDesktop() && Typo.h3_RDesktop,
                        Margin.mb_0,
                        { fontFamily: FontFamily.abrilFatface },
                        {
                          fontSize: helpers.isDesktop() ? 24 : 18,
                          color: "#7B8FFE",
                        },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 10, paddingVertical: 5 },
                      ]}
                    >
                      {data.title}
                    </Text>
                  </View>
                </View>
              </View>
            )}
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...startUpProp}
                handleClick={() => this.trackThemeClick("startups")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Startups
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>15 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase'}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...fintechProp}
                handleClick={() => this.trackThemeClick("fintech")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Fintech
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>5 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...retailProp}
                handleClick={() => this.trackThemeClick("retail")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Retail
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>2 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...eCommProp}
                handleClick={() => this.trackThemeClick("e-commerce")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      E-commerce
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>10 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...mediaProp}
                handleClick={() => this.trackThemeClick("media")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Media
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>23 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...itProp}
                handleClick={() => this.trackThemeClick("media")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      IT
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>23 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...technologyProp}
                handleClick={() => this.trackThemeClick("media")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Aviation
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>23 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...telecomProp}
                handleClick={() => this.trackThemeClick("media")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Telecom
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>23 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...edtechProp}
                handleClick={() => this.trackThemeClick("media")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      EdTech
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>23 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...financeProp}
                handleClick={() => this.trackThemeClick("media")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Banking & Finance
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>23 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
            <View
              style={[
                !helpers.isDesktop() && { padding: 10 },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <TouchableOpacityLink
                {...environmentProp}
                handleClick={() => this.trackThemeClick("media")}
              >
                <View
                  style={[
                    {
                      borderWidth: 1,
                      borderColor: "#7B8FFE",
                      borderRadius: 30,
                      backgroundColor: "#fff",
                    },
                    !helpers.isDesktop() && {
                      paddingBottom: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    !process.browser && { width: 300 },
                    !helpers.isWeb() && { width: "100%" },
                    darkMode && { backgroundColor: "#1E1E1E" },
                  ]}
                >
                  <View
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      Flex.justifyBetween,
                      { alignItems: "baseline" },
                      !webView && { alignItems: "center" },
                    ]}
                  >
                    <Text
                      style={[
                        popularStories.imageTitle,
                        helpers.isDesktop() && popularStories.imageTitleDesktop,
                        { color: "#7B8FFE" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                        { paddingHorizontal: 20, paddingVertical: 5 },
                      ]}
                    >
                      Environment
                    </Text>
                    {/* {!helpers.isDesktop() && <Text style={[popularStories.articleCount]}>23 <Text style={{fontSize: 11, lineHeight: 13, textTransform: 'uppercase', position: 'relative', top: -1}}>articles</Text></Text>} */}
                  </View>
                </View>
              </TouchableOpacityLink>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

export default AuthenticationWrapper(HomePopularCategories);
